export default "__VITE_ASSET__CDb7Z_RN__"